import _ from 'lodash';
import domains from '../containers/Domains';
import contextMakePost from './Context';
import {getLocalStorageDataOrFetch} from './fbCallManager';

const endpoint = domains.fbEndpoint;

export const launchCanvas = async (id, token) => {
  const parameters = {
    access_token: token,
    is_published: true
  };

  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const createCanvas = async (data, token) => {
  const parameters = {
    access_token: token,
    background_color: data.theme,
    body_element_ids: data.bodyElements,
    name: data.name,
    is_published: data.is_published,
    enable_swipe_to_open: data.enable_swipe_to_open
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const getCanvas = async (id, token) => {
  const parameters = {
    access_token: token,
    id,
    fields:
      'id,name,canvas_link,body_elements,background_color,owner{id,access_token}'
  };

  const query = _.template(
    `${endpoint}<%= id%>?&fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters))
  
  return jsonResult;
};

export const duplicateCanvas = async (id, token) => {
  const parameters = {
    access_token: token
  };

  const result = await contextMakePost(parameters, `${id}/duplicate_canvas`);
  return result.json();
};

export const getCanvasFull = async (id, token) => {
  const parameters = {
    access_token: token,
    id,
    fields:
      'body_elements{child_elements{rich_text,action},element_type,style,item_headline,item_description,name,product_set_id},owner{id,access_token},is_hidden,is_published,background_color,canvas_link,name'
  };
  const query = _.template(
    `${endpoint}<%= id%>?&fields=<%= fields%>&access_token=<%= access_token%>`
  );
  
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters))
  
  return jsonResult;
};

export const getCanvasElement = async (id, token) => {
  const parameters = {
    access_token: token,
    id,
    fields: 'id,name,product_set_id'
  };

  const query = _.template(
    `${endpoint}<%= id%>?&fields=<%= fields%>&access_token=<%= access_token%>`
  );
  
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters))
  
  return jsonResult;
};

export const getCanvasVideo = async (id, token) => {
  const parameters = {
    access_token: token,
    id,
    fields: 'id,name,video,style'
  };

  const query = _.template(
    `${endpoint}<%= id%>?&fields=<%= fields%>&access_token=<%= access_token%>`
  );
  
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters))
  
  return jsonResult;
};

export const getCanvasesFromPage = async (pageId, token) => {
  const parameters = {
    access_token: token,
    fields: 'update_time,is_published,is_hidden,id,name,owner&limit=100000'
  };

  const query = _.template(
    `${endpoint}${pageId}/canvases?&fields=<%= fields%>&access_token=<%= access_token%>`
  );
  
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters))
  
  return jsonResult;
};

export const getPageOwner = async (ownerId, token) => {
  const query = `${endpoint}${ownerId}?fields=access_token&access_token=${token}`;

  const jsonResult = await getLocalStorageDataOrFetch(query)
  
  return jsonResult;
};

export const updateCanvasVideo = async (canvasVideoId, newVideoId, token) => {
  const parameters = {
    access_token: token,
    video_id: newVideoId
  };

  const result = await contextMakePost(parameters, canvasVideoId);
  return result.json();
};


// WEBPACK FOOTER //
// ./src/fbApi/Canvas.js